<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 id="modal-title">{{ modalData.title }}</h1>
    </header>
    <section id="modal-body">
        <p>{{ modalData.description }}</p>
    </section>
    <footer id="modal-footer">
        <button mat-raised-button id="modal-action-button" (click)="actionFunction()">
            {{ modalData.actionButtonText }}
        </button>
        <button mat-raised-button id="modal-cancel-button" (click)="closeModal()">
            Go back
        </button>
    </footer>
</div>